'use client';

export type HomeTab = 'trends' | 'feed' | 'ideas' | 'history';
export type HistoryFilter = 'photo' | 'video' | 'music' | 'chat';

export interface HomeNavigationState {
  tab: HomeTab;
  historyFilter?: HistoryFilter;
}

const HOME_NAVIGATION_STORAGE_KEY = 'home-navigation-state';

export function dispatchHomeNavigation(state: HomeNavigationState) {
  window.dispatchEvent(new CustomEvent<HomeNavigationState>('home-navigation', { detail: state }));
}

export function persistHomeNavigation(state: HomeNavigationState) {
  window.sessionStorage.setItem(HOME_NAVIGATION_STORAGE_KEY, JSON.stringify(state));
}

export function consumeStoredHomeNavigation(): HomeNavigationState | null {
  const raw = window.sessionStorage.getItem(HOME_NAVIGATION_STORAGE_KEY);
  if (!raw) return null;

  window.sessionStorage.removeItem(HOME_NAVIGATION_STORAGE_KEY);

  try {
    const parsed = JSON.parse(raw) as Partial<HomeNavigationState>;
    if (
      parsed.tab === 'trends' ||
      parsed.tab === 'feed' ||
      parsed.tab === 'ideas' ||
      parsed.tab === 'history'
    ) {
      return {
        tab: parsed.tab,
        historyFilter:
          parsed.historyFilter === 'photo' ||
          parsed.historyFilter === 'video' ||
          parsed.historyFilter === 'music' ||
          parsed.historyFilter === 'chat'
            ? parsed.historyFilter
            : undefined,
      };
    }
  } catch {
    return null;
  }

  return null;
}
